import { render, staticRenderFns } from "./Grants.vue?vue&type=template&id=70adbd78"
import script from "./Grants.vue?vue&type=script&lang=js"
export * from "./Grants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports